import React, { Fragment } from "react";
import CssBaseline from '@material-ui/core/CssBaseline';
import Router from "Components/Router/Router";
import appStyles from './app.style';
import { withStyles } from "@material-ui/core/styles";
import { withLDProvider } from "launchdarkly-react-client-sdk";

import './app.style.less'

const App = () => {
  return (
    <Fragment>
        <CssBaseline />
        <Router />
    </Fragment>
  )
};

const withStylesApp = withStyles(appStyles)(App);

const qaLDClientID = "65cfa316edc7e810655f88eb"
export default withLDProvider({
  clientSideID: process.env.LAUNCHDARKLY_CLIENT_ID || qaLDClientID,
  context: {
      kind: "user",
      key: "all-users"
  }
})(withStylesApp);



// WEBPACK FOOTER //
// ./src/components/AppContainer/App/App.js